import templates from '../templates';
import Workspace from '../../workspaces';

const saveSnapshotDialog = async () => {
    let kendoAlert;
    let $container;

    const onClose = () => {
        kendoAlert.destroy();
        $container.remove();
    };

    const create = async () => {
        $container = $(document.createElement('div'));
        $container.appendTo('body');

        let $template = $(templates('dialog-snapshots', { list: Workspace.list() }));

        $template.find('.snapshot-item').on('click', async (e) => {
            const id = $(e.target).data('id');
            Workspace.doRestore(id);
        });

        $template.find('.fa-trash-o').on('click', async (e) => {
            const id = $(e.target).parent().data('id');

            Workspace.remove(id);

            $template.find('.list-group-body li').each((index, el) => {
                if ($(el).find('.snapshot-item').data('id') === id) {
                    $(el).remove();
                }
            });
        });

        $template.find('.search-input').on('input', async (e) => {
            $template.find('.list-group-body li').each((index, el) => {
                if (index === 0) { return; }

                if ($(el).find('.snapshot-item').text().toLowerCase().indexOf(e.target.value) >= 0) {
                    $(el).show();
                } else {
                    $(el).hide();
                }
            });
        });

        kendoAlert = $container.kendoAlert({
            width: '360px',
            title: false,
            closable: false,
            modal: false,
            content: $template,
            close: onClose,
        }).data('kendoAlert').open();
    };

    await create();
};

export default saveSnapshotDialog;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/snapshot-load.js